if (!customElements.get("highlights-swiper")) {
  class HighlightsSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const desktopView = parseFloat(this.dataset.desktopView) || 4;
      const mobileView = this.dataset.mobileView === 'auto' ? 'auto' : (parseFloat(this.dataset.mobileView) || 1.2);

      const autoplayDelay = (parseFloat(this.dataset.autoplayDelay) || 5) * 1000;
 
      const options = {
        slidesPerView: mobileView,
        spaceBetween: 0,
        freeMode: true,
        watchOverflow: true,
        loop: true,
        autoplay: {
          delay: autoplayDelay,
          disableOnInteraction: false,
        },
        breakpoints: {
          480: { slidesPerView: 2.2, spaceBetween: 10 },
          640: { slidesPerView: 3.2, spaceBetween: 10 },
          768: { slidesPerView: 'auto', spaceBetween: 10 },
        },
      };

      this.swiper = new Swiper(this, options);
    }
  }

  customElements.define("highlights-swiper", HighlightsSwiper);
}
